import type { TUser, TUserType } from 'src/types';
import get from 'lodash/get';
import { useMemo } from 'react';
import { useGetCurrentUser } from './useGetCurrentUser';

export const isInMyTeam = (
    currentUser: TUser & { isAdmin: boolean; isManager: boolean; isEmployee: boolean },
    currentUserManagerId: string,
    user: TUser,
    skipUsersCoWorkers?: boolean
) => {
    const currentUserId = get(currentUser, 'id', '');

    return (
        user.manager?.id === currentUserId || // If current user is manager for user
        (user.manager?.id === currentUserManagerId && !skipUsersCoWorkers) || // If current user belong to one manager with user
        user.id === currentUserManagerId || // If this is current user manager's booking
        user.id === currentUserId // If this current user
    );
};

type ParamsType = {
    type: TUserType;
    skipCurrentUserManager: boolean;
    users: TUser[];
    skipUsersCoWorkers?: boolean;
};

export const useFilterUsersByTeam = (params: ParamsType) => {
    const { type, skipCurrentUserManager, users, skipUsersCoWorkers } = params;
    const currentUser = useGetCurrentUser();

    const currentUserManagerId = currentUser.manager?.id || '';

    const usersFiltered: TUser[] = useMemo(() => {
        return (users || []).filter((user) => {
            if (type === 'me') {
                return user.id === currentUser.id;
            }
            if (type === 'all') {
                return user;
            }
            return (
                isInMyTeam(currentUser, currentUserManagerId, user, skipUsersCoWorkers) &&
                ((skipCurrentUserManager && user.id !== currentUserManagerId) ||
                    !skipCurrentUserManager)
            );
        });
    }, [
        currentUser,
        currentUserManagerId,
        skipCurrentUserManager,
        skipUsersCoWorkers,
        type,
        users,
    ]);

    return {
        users: usersFiltered,
    };
};
